export const ADD_TO_PROPERTY_GROUP_STARTING_POINT = 'add-property-group';
export const ADD_TO_PROPERTY_GROUP_ENDING_POINT = 'save-existing-property-group';
export const CREATE_NEW_PROPERTY_GROUP_ENDING_POINT = 'save-new-property-group';
